import React, {useEffect} from "react";
import {useHistory} from "react-router-dom";
import {Trans, useTranslation} from "react-i18next";
import CouponBox from "../CouponBox";
import {useCookies} from "react-cookie";
import {Box, Button, Grid, Hidden, makeStyles, Typography,} from "@material-ui/core";
import apiHelper from "../../utils/apiHelper";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import {getTodayWithoutTime} from "../../utils/helper";

dayjs.extend(isBetween);

const useStylesAll = makeStyles((theme) => ({
  pageContainer: {
    display: "flex",
    justifyContent: "center",
  },
  container: {
    fontFamily: "Poppins",
    width: "100%",
    color: "#000000",
    padding: "10px 15px",
    [theme.breakpoints.up("md")]: {
      width: "85%",
      maxWidth: 1140,
      padding: "30px",
    },
    marginTop: "50px",
  },
  btn: {
    marginTop: "30px",
    [theme.breakpoints.up("md")]: {
      marginTop: "40px",
    },
  },

  fieldName: {
    marginBottom: 0,
    fontSize: "13px",
    [theme.breakpoints.up("md")]: {
      fontSize: "14px",
    },
  },
  fieldValue: {
    marginTop: "3px",
    color: "#000000",
  },
  smallBtn: {
    textAlign: "right",
    width: "fit-content",
    fontSize: "14px",
    color: "#999999",
    borderColor: "#CCCCCC",
    padding: "5px 15px",
    "&:hover": {
      backgroundColor: "#eeeeee",
    },
  },
  right: {
    textAlign: "right",
  },

  highlight: {
    color: "#962013",
    textDecoration: "none",
    // fontWeight: "bold",
  },
  endSoonReminder: {
    backgroundColor: "#F9F9F9",
    border: "1px solid #CCCCCC",
    padding: "8px 15px",
    borderRadius: "7px",
    [theme.breakpoints.up("sm")]: {
      padding: "10px 15px",
      marginBottom: "20px",
    },
  },
  renewBtn: {
    color: "#FFFFFF",
    backgroundColor: "#962013",
    border: "none",
    padding: "5px 8px",
    fontSize: "13px",
    fontWeight: "bold",
    '&:hover': {
      backgroundColor: "#901F12",
    },
    [theme.breakpoints.up("sm")]: {
      padding: "5px 15px",
      fontSize: "14px",
    },
  },
  classic: {
    color: "#c7c6c6",
  },
  patron: {
    color: "#f0b251",
  },
  mcContainer: {
    position: "absolute",
    width: "360px",
    height: "779px",
    textAlign: "center",
  },
  // mcImgContainer: {

  //   margin: "160px auto 80px",
  //   overflow:"hidden",
  //   textAlign:"center",
  //   width: "221px",
  //   height: "126px",
  // },
  // mcImgContainer: {
  //   display: "inline-block",
  //   width: "221px",
  //   height: "126px",
  //   backgroundPosition: "center center",
  //   backgroundSize: "cover",
  //   margin: "160px auto 80px",
  // },
  mcImgContainer: {
    width: "221px",
    height: "126px",
    margin: "160px auto 80px",
  },
  mcImg: {
    height: "126px",
    width: "100%",

    // position: "relative",
    // height: "126px",
    // maxWidth: "221px",
    // margin: "160px auto 80px",

    // width: theme.spacing(25),
    // height: theme.spacing(25),
  },
  contain: {
    objectFit: "contain",
  },
  cover: {
    objectFit: "cover",
  },
  mc: {
    position: "relative",
    // top: "37.5%",
    width: "100%",
    "& span": {
      display: "block",
      // color: "#FFFFFF",
    },
  },
  mcL: {
    textTransform: "uppercase",
    fontSize: "29px",
    fontWeight: "900",
    lineHeight: "35px",
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  mcM: {
    fontSize: "16px",
    lineHeight: "30px",
  },
  mcS: {
    fontSize: "12px",
    lineHeight: "15px",
    marginTop: "2px",
  },
}));

const defaultProfile = {
  firstName: "",
  lastName: "",
  gender: "",
  address: "",
  contactNumber: "",
  email: "",
  dob: "",
  iconImage: "",
};

const defaultPlan = {
  detail: [],
  id: "",
  name: "",
  price: "",
};

function ProfilePage(props) {
  const {t, i18n} = useTranslation("profile");
  const classes = useStylesAll();
  const [isDisabled, setIsDisabled] = React.useState(true);
  const [isEndSoon, setIsEndSoon] = React.useState(false);
  const [isExpired, setIsExpired] = React.useState(false);
  const [discount, setDiscount] = React.useState("");
  const [cookies, setCookie] = useCookies();
  const [profile, setProfile] = React.useState(defaultProfile);
  const [plan, setPlan] = React.useState(defaultPlan);
  const [showCoupon, setShowCoupon] = React.useState(false);
  const [isPromotionPeriod, setIsPromotionPeriod] = React.useState(false);
  const [canClaimPromotionBenefit, setCanClaimPromotionBenefit] = React.useState(false);
  const history = useHistory();
  const [objectFit, setObjectFit] = React.useState("cover");

  const [planName, setPlanName] = React.useState("");
  const [expiryDateddmmyy, setExpiryDateddmmyy] = React.useState("");
  const [firstName, setFirstName] = React.useState("");
  const imgRef = React.createRef(null);

  function toCouponsList() {
    history.push("/" + i18n.language + "/profile/coupons");
  }

  function toProfileEdit() {
    history.push("/" + i18n.language + "/profile/edit");
  }

  function getRenewalDiscount() {
    try {
      apiHelper
        .getPlanInfo(i18n.language, cookies.token)
        .then(function (response) {
          setDiscount(100 - response.data.renewalDiscount * 100);
          setIsPromotionPeriod(response.data.insidePromotionPeriod);
        })
        .catch(function (error) {
          console.log(error);
        });
    } catch (err) {
      console.log(err);
    }
  }

  useEffect(() => {
    if (cookies.token) {
      try {
        apiHelper
          .getMemberInfo(cookies.token)
          .then((response) => {
            setCanClaimPromotionBenefit(response.data.canClaimPromotionBenefit)
          })
          .catch(console.error)
        apiHelper
          .getMemberProfile(cookies.token)
          .then(function (response) {
            var date = new Date(response.data.dob);
            var dd = String(date.getDate()).padStart(2, "0");
            var mm = String(date.getMonth() + 1).padStart(2, "0"); //January is 0!
            var yyyy = date.getFullYear();

            var dob = mm + "/" + yyyy;

            response.data.dob = dob;

            setProfile(response.data);
            setFirstName(response.data.firstName);
          })
          .catch(function (error) {
            console.log("member profile error");
            console.log(error);
          });

        apiHelper
          .getMemberCurrentPlan(cookies.token)
          .then(function (response) {
            setPlan(response.data);
            setPlanName(response.data.name);
          })
          .catch(function (error) {
            console.log("member current-plan error");
            console.log(error);
          });
      } catch (e) {
        console.log(e);
      }
    }
  }, [cookies.token]);

  useEffect(() => {
    if (cookies.expiryDate) {
      var expiryDate = new Date(cookies.expiryDate);
      var dd = String(expiryDate.getDate()).padStart(2, "0");
      var mm = String(expiryDate.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yy = String(expiryDate.getFullYear()).substr(2, 3);
      expiryDate = dd + "/" + mm + "/" + yy;
      setExpiryDateddmmyy(expiryDate);

      getRenewalDiscount();
      var expiryDate = new Date(cookies.expiryDate);
      var oneMonthLater = new Date();
      oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
      var isEndSoon = expiryDate < oneMonthLater;
      var isExpired = expiryDate < getTodayWithoutTime();
      if (isEndSoon) {
        setIsEndSoon(isEndSoon);
      }
      if (isExpired) {
        setIsExpired(isExpired);
      }
    }
  }, [cookies.expiryDate]);

  function MemberCard(props) {
    const {plan, img, isMobile} = props;
    var planName = plan.name.toLowerCase();
    var imagePath = "/images/classic_card.png";
    if (plan.name == "Patron") {
      imagePath = "/images/patron_card.png";
    }
    var width = isMobile ? (width = "278px") : "";

    return (
      <>
        <span className={`${classes.mcContainer} ${classes[planName]}`}>
          {/* <Avatar alt="" src={img} className={classes.mcImg} variant="square" /> */}
          <div className={classes.mcImgContainer}>
            <img
              ref={imgRef}
              src={img}
              className={`${classes.mcImg} ${classes[objectFit]}`}
              onLoad={() => {
                if (imgRef.current) {
                  var ratio =
                    imgRef.current.naturalWidth / imgRef.current.naturalHeight;
                  var bgRatio =
                    imgRef.current.clientWidth / imgRef.current.clientHeight;
                  if (ratio > bgRatio) {
                    setObjectFit("cover");
                  } else {
                    setObjectFit("contain");
                  }
                }
              }}
            />
          </div>

          {/* <div className={classes.mcImgContainer} style={{backgroundImage: `url('${img}')`}}>
</div> */}
          <span className={classes.mc}>
            <span className={classes.mcL} style={{marginBottom: "20px"}}>
              <span style={{display: "inline-block", marginRight: "5px"}}>
                {profile.firstName}{" "}
              </span>
              <span style={{display: "inline-block"}}>
                {profile.lastName}
              </span>
            </span>
            <span className={classes.mcM}>{t("validtill")}</span>
            <span className={classes.mcL}>{expiryDateddmmyy}</span>
            <span className={classes.mcS}>(dd/mm/yy)</span>
          </span>
        </span>
        <img {...width} src={imagePath}/>
      </>
    );
  }

  function toRenew() {
    history.push("/" + i18n.language + "/renew");
  }

  return (
    <Box className={classes.pageContainer}>
      <Box className={classes.container}>
        <Grid container spacing={4}>
          <Grid item xs={12}>
            <Typography variant="h1">
              {t("title")} {firstName}
            </Typography>

            {/*{(isExpired) && (*/}
            {/*  <Box className={classes.endSoonReminder}>*/}
            {/*    <Grid*/}
            {/*      container*/}
            {/*      spacing={1}*/}
            {/*      direction="row"*/}
            {/*      justifyContent="space-between"*/}
            {/*      alignItems="center"*/}
            {/*    >*/}
            {/*      <Grid item xs={8} md={10}>*/}
            {/*        <Typography variant="h3">*/}
            {/*          {isExpired ? (*/}
            {/*            t("expiredreminder")*/}
            {/*          ) : (*/}
            {/*            <>*/}
            {/*              <Trans*/}
            {/*                t={t}*/}
            {/*                i18nKey="reminder.prefix"*/}
            {/*                values={{planName, expiryDateddmmyy}}*/}
            {/*                components={[*/}
            {/*                  <span className={classes.highlight}/>,*/}
            {/*                ]}*/}
            {/*              />*/}
            {/*              {discount > 0 ? (*/}
            {/*                <Trans*/}
            {/*                  t={t}*/}
            {/*                  i18nKey="reminder.suffix-discount"*/}
            {/*                  values={{discount}}*/}
            {/*                  components={[*/}
            {/*                    <span className={classes.highlight}/>,*/}
            {/*                  ]}*/}
            {/*                />*/}
            {/*              ) : (*/}
            {/*                <Trans*/}
            {/*                  t={t}*/}
            {/*                  i18nKey="reminder.suffix-normal"*/}
            {/*                  components={[*/}
            {/*                    <span className={classes.highlight}/>,*/}
            {/*                  ]}*/}
            {/*                />*/}
            {/*              )}*/}
            {/*            </>*/}
            {/*          )}*/}
            {/*        </Typography>*/}
            {/*      </Grid>*/}
            {/*      <Grid item xs={4} md={2} className={classes.right}>*/}
            {/*        <Button*/}
            {/*          type="button"*/}
            {/*          className={classes.renewBtn}*/}
            {/*          variant="outlined"*/}
            {/*          onClick={toRenew}*/}
            {/*        >*/}
            {/*          {t("renewnowbtn")}*/}
            {/*        </Button>*/}
            {/*      </Grid>*/}
            {/*    </Grid>*/}
            {/*  </Box>*/}
            {/*)}*/}
          </Grid>

            <>
              {!isExpired && (
                <Hidden lgUp>
                  <Grid
                    item
                    xs={12}
                    style={{textAlign: "center", position: "relative"}}
                  >
                    <MemberCard plan={plan} img={profile.iconImage}/>
                  </Grid>
                </Hidden>
              )}

              <Grid item xs={12} lg={8}>
                {showCoupon ? (
                  <Grid container spacing={1}>
                    <Grid item xs={8}>
                      <Typography variant="h3" style={{marginBottom: 0}}>
                        {t("Your Coupon")}
                      </Typography>
                    </Grid>
                    <Grid item xs={4} className={classes.right}>
                      <Button
                        type="button"
                        className={classes.smallBtn}
                        variant="outlined"
                        onClick={() => {
                          toCouponsList();
                        }}
                      >
                        {t("View All")}
                      </Button>
                    </Grid>
                    <Grid item xs={12}>
                      <Grid
                        container
                        spacing={3}
                        direction="row"
                        justifyContent="flex-start"
                        alignItems="center"
                      >
                        <CouponBox
                          amount="10"
                          validUntil="2022/12/13"
                          expired={false}
                        />
                        <CouponBox
                          amount="10"
                          validUntil="2022/12/13"
                          expired={false}
                        />
                        <Hidden smDown>
                          <CouponBox
                            amount="10"
                            validUntil="2021/01/11"
                            expired={true}
                          />
                        </Hidden>
                      </Grid>
                    </Grid>
                  </Grid>
                ) : (
                  <></>
                )}

                <Grid container spacing={1} style={{marginTop: "40px"}}>
                  <Grid item xs={8}>
                    <Typography variant="h3" style={{marginBottom: 0}}>
                      {t("yourprofile")}
                    </Typography>
                  </Grid>
                    {
                      !isExpired && (
                        <Grid item xs={4} className={classes.right}>
                          <Button
                            type="button"
                            className={classes.smallBtn}
                            variant="outlined"
                            onClick={() => {
                              toProfileEdit();
                            }}
                          >
                            {t("edit")}
                          </Button>
                        </Grid>
                      )
                    }
                  <Grid item xs={6}>
                    <Typography variant="h3" className={classes.fieldName}>
                      {t("firstName.label")}
                    </Typography>
                    <Typography variant="h3" className={classes.fieldValue}>
                      {profile.firstName}
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <Typography variant="h3" className={classes.fieldName}>
                      {t("lastName.label")}
                    </Typography>
                    <Typography variant="h3" className={classes.fieldValue}>
                      {profile.lastName}
                    </Typography>
                  </Grid>
                </Grid>
                <Typography variant="h3" className={classes.fieldName}>
                  {t("address.label")}
                </Typography>
                <Typography variant="h3" className={classes.fieldValue}>
                  {profile.address}
                </Typography>
                <Typography variant="h3" className={classes.fieldName}>
                  {t("contactNumber.label")}
                </Typography>
                <Typography variant="h3" className={classes.fieldValue}>
                  {profile.contactNumber}
                </Typography>
                <Typography variant="h3" className={classes.fieldName}>
                  {t("email.label")}
                </Typography>
                <Typography variant="h3" className={classes.fieldValue}>
                  {profile.email}
                </Typography>
                <Typography variant="h3" className={classes.fieldName}>
                  {t("dob.label")}
                </Typography>
                <Typography variant="h3" className={classes.fieldValue}>
                  {profile.dob}
                </Typography>

                {/* {
                  (
                    (!isPromotionPeriod && dayjs().isBetween(dayjs(new Date(cookies.expiryDate)).subtract(2, 'week'), new Date(cookies.expiryDate), 'day', '[]'))
                    ||
                    (isPromotionPeriod && canClaimPromotionBenefit)
                    ||
                    isExpired
                  )
                  ?
                  <Grid item xs={4}>
                    <Button
                      type="button"
                      className={classes.renewBtn}
                      variant="outlined"
                      onClick={() => {
                        toRenew();
                      }}
                    >
                      {isExpired ? t("rejoin") : t("renew")}
                    </Button>
                  </Grid>
                  :
                  <Typography variant="h3" style={{marginTop: "20px"}}>
                    {t("renewremark")}
                  </Typography>
                } */}
              </Grid>
              {!isExpired && (
                <Hidden mdDown>
                  <Grid item lg={4}>
                    <MemberCard
                      plan={plan}
                      img={profile.iconImage}
                      isMobile={true}
                    />
                  </Grid>
                </Hidden>
              )}
            </>

          <Grid item xs={12}>
            <a className={classes.highlight} href="https://usercontent.hkiff.org.hk/hkiff/HKIFF_CineClub_TNC.pdf"
               target="_blank">{t('joiningtnc')}</a>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ProfilePage;
